import { Link, NavLink } from "react-router-dom";
import { cn } from "@/lib/cn";

const NAV = [
  { to: "/", label: "Inicio" },
  { to: "/eg2026", label: "EG 2026" },
  { to: "/erm2026/jee", label: "ERM 2026" },
  { to: "/erm2026/del-palacio-al-concejo", label: "Ensayos" },
];

export function Header() {
  return (
    <header className="sticky top-0 z-30 border-b-2 border-brand-red bg-white/95 backdrop-blur shadow-sm">
      <div className="container-prose flex h-20 items-center justify-between gap-4">
        <Link
          to="/"
          className="flex items-center gap-3 shrink-0"
          aria-label="VerdadElectoral · Inicio"
        >
          <img
            src="/logo.svg"
            alt="VerdadElectoral"
            className="h-10 md:h-12 w-auto max-w-[280px] object-contain select-none"
            draggable="false"
          />
          <div className="leading-tight hidden lg:block border-l border-slate-200 pl-3">
            <div className="text-[11px] uppercase tracking-widest text-brand-navy/70 font-semibold">
              Centro ciudadano
            </div>
            <div className="text-[11px] uppercase tracking-widest text-brand-red/80 font-semibold">
              EG2026 · ERM2026
            </div>
          </div>
        </Link>
        <nav className="hidden md:flex items-center gap-1">
          {NAV.map((item) => (
            <NavLink
              key={item.to}
              to={item.to}
              end={item.to === "/"}
              className={({ isActive }) =>
                cn(
                  "rounded-md px-3 py-1.5 text-sm font-semibold transition",
                  isActive
                    ? "bg-brand-navy text-white"
                    : "text-brand-navy hover:bg-brand-navy-100"
                )
              }
            >
              {item.label}
            </NavLink>
          ))}
        </nav>
      </div>
    </header>
  );
}
